import { Page } from 'layouts/Page';
import { FC } from 'react';
import { EudrService } from 'components/EudrService/';

export const EudrServicePage: FC = () => {
	return (
		<Page title="EUDR Service – EAS Dashboard">
			<EudrService />
		</Page>
	);
};
